import { render, staticRenderFns } from "./landing-quote.vue?vue&type=template&id=aa15b516&lang=html"
import script from "./landing-quote.vue?vue&type=script&lang=js"
export * from "./landing-quote.vue?vue&type=script&lang=js"
import style0 from "./landing-quote.vue?vue&type=style&index=0&id=aa15b516&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports